import axios from "axios";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

function ResetPassword() {
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const { token } = useParams();

    async function handleSubmit(e: any) {
        e.preventDefault();
        setError('');
        setMessage('');
        if (password !== repeatPassword) {
            setError("Passwords do not match.");
            return;
        }
        setLoading(true);

        try {
            const response = await axios.post(
                `/api/v1/authenticate/reset-password/${token}`,
                JSON.stringify({ password, repeatPassword }),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            setMessage(response.data?.message || "Password reset successful.");
            setPassword('');
            setRepeatPassword('');
            setTimeout(() => navigate('/'), 3000)
        } catch (err: any) {
            setError(err.response?.data?.errors?.[0]?.message || "Password reset failed. Please try again.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
            <form
                className="w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8"
                onSubmit={handleSubmit}
            >
                <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6 text-center">
                    Reset Password
                </h2>
                {error && (
                    <p className="text-red-500 text-sm text-center mb-4">
                        {error}
                    </p>
                )}
                {message && (
                    <p className="text-green-500 text-sm text-center mb-4">
                        {message}
                    </p>
                )}
                <div className="mb-5">
                    <label
                        htmlFor="password"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                        New Password
                    </label>
                    <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        required
                    />
                </div>
                <div className="mb-5">
                    <label
                        htmlFor="repeatPassword"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                        Repeat Password
                    </label>
                    <input
                        type={showPassword ? "text" : "password"}
                        id="repeatPassword"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        value={repeatPassword}
                        required
                    />
                </div>
                <div className="mb-5 flex items-center">
                    <input
                        type="checkbox"
                        id="showPassword"
                        className="mr-2"
                        onChange={() => setShowPassword(!showPassword)}
                        checked={showPassword}
                    />
                    <label
                        htmlFor="showPassword"
                        className="text-sm font-medium text-gray-900 dark:text-white"
                    >
                        Show Password
                    </label>
                </div>
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:opacity-50"
                >
                    {loading ? 'Resetting Password...' : 'Reset Password'}
                </button>
            </form>
        </div>
    );
};

export default ResetPassword;
